import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../hooks/CustomHook';
import axios from 'axios';
import Notiflix from 'notiflix';
import config from '../config/config';

const Contact = () => {
    const app_logo = config.appLogoUrl
    useDocTitle('江西族迹 | 联系我们')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [errors, setErrors] = useState([])

    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
    }

    const sendEmail = (e) => {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = '发送中...';
        let fData = new FormData();
        fData.append('first_name', firstName)
        fData.append('last_name', lastName)
        fData.append('email', email)
        fData.append('phone_number', phone)
        fData.append('message', message)

        axios({
            method: "post",
            url: process.env.REACT_APP_CONTACT_API,
            data: fData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response) {
                document.getElementById('submitBtn').disabled = false;
                document.getElementById('submitBtn').innerHTML = '发送消息';
                clearInput()
                //handle success
                Notiflix.Report.success(
                    '发送成功',
                    response.data.message,
                    '确定',
                );
            })
            .catch(function (error) {
                document.getElementById('submitBtn').disabled = false;
                document.getElementById('submitBtn').innerHTML = '发送消息';
                //handle error
                const { response } = error;
                if (response.status === 500) {
                    Notiflix.Report.failure(
                        '发生错误',
                        response.data.message,
                        '确定',
                    );
                }
                if (response.data.errors !== null) {
                    setErrors(response.data.errors)
                }

            });
    }

    return (
        <>
            <NavBar />
            <div id='contact' className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-12 lg:py-24">
                <div className="container mx-auto px-4 lg:px-8">
                    {/* 页面标题 */}
                    <div className="text-center mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">联系我们</h1>
                        <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                            有任何问题或建议，欢迎随时与我们联系
                        </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                        {/* 联系信息卡片 */}
                        <div
                            className="lg:col-span-1 bg-gradient-to-br from-blue-600 to-blue-800 text-white rounded-2xl shadow-2xl p-8 lg:p-10"
                        >
                            <div className="mb-8">
                                <div className="flex items-center mb-6">
                                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                                        <img src={app_logo} />
                                    </div>
                                    <div>
                                        <h2 className="text-2xl font-bold">江西族迹</h2>
                                        <p className="text-blue-200 text-sm">连接家族 · 传承记忆</p>
                                    </div>
                                </div>
                                <p className="text-blue-100 leading-relaxed">
                                    我们致力于通过科技手段帮助每个家庭保存和传承珍贵的家族记忆
                                </p>
                            </div>

                            {/* 联系信息 */}
                            <div className="space-y-6">
                                {/* 地址 */}
                                <div className="flex items-start group">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 mt-1 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">办公地址</h3>
                                        <p className="text-blue-200 text-sm">江西省南昌市红谷滩区</p>
                                        <p className="text-blue-200 text-sm">红谷中大道998号绿地中央广场</p>
                                        <p className="text-blue-200 text-sm">A1#办公室5206-2室</p>
                                    </div>
                                </div>

                                {/* 电话 */}
                                <div className="flex items-center group">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">联系电话</h3>
                                        <a href="tel:+8613812345678" className="text-blue-200 hover:text-white transition-colors duration-300 text-sm">
                                            4001818105
                                        </a>
                                    </div>
                                </div>

                                {/* 邮箱 */}
                                <div className="flex items-center group">
                                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">电子邮箱</h3>
                                        <a href="mailto:postmaster@sayfamily.cn" className="text-blue-200 hover:text-white transition-colors duration-300 text-sm">
                                            ryan@sayfamily.com
                                        </a>
                                    </div>
                                </div>
                            </div>


                        </div>

                        {/* 联系表单 */}
                        <div
                            className="lg:col-span-2 bg-white rounded-2xl shadow-2xl p-8 lg:p-10"
                        >
                            <form onSubmit={sendEmail}>
                                <div className="mb-8">
                                    <h2 className="text-3xl font-bold text-gray-800 mb-2">发送消息</h2>
                                    <p className="text-gray-600">填写以下表单，我们会尽快与您联系</p>
                                </div>

                                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 mb-6">
                                    {/* 姓氏 */}
                                    <div>
                                        <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="first_name">
                                            姓氏 *
                                        </label>
                                        <input
                                            id="first_name"
                                            name="first_name"
                                            className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            type="text"
                                            placeholder="请输入您的姓氏"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-2">{errors.first_name}</p>
                                        }
                                    </div>

                                    {/* 名字 */}
                                    <div>
                                        <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="last_name">
                                            名字 *
                                        </label>
                                        <input
                                            id="last_name"
                                            name="last_name"
                                            className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            type="text"
                                            placeholder="请输入您的名字"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-2">{errors.last_name}</p>
                                        }
                                    </div>

                                    {/* 邮箱 */}
                                    <div>
                                        <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email">
                                            电子邮箱 *
                                        </label>
                                        <input
                                            id="email"
                                            name="email"
                                            className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            type="email"
                                            placeholder="请输入您的邮箱"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-2">{errors.email}</p>
                                        }
                                    </div>

                                    {/* 电话 */}
                                    <div>
                                        <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="phone_number">
                                            联系电话 *
                                        </label>
                                        <input
                                            id="phone_number"
                                            name="phone_number"
                                            className="w-full bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            type="tel"
                                            placeholder="请输入您的电话"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors &&
                                            <p className="text-red-500 text-sm mt-2">{errors.phone_number}</p>
                                        }
                                    </div>
                                </div>

                                {/* 消息内容 */}
                                <div className="mb-8">
                                    <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="message">
                                        消息内容 *
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="请详细描述您的问题或需求..."
                                        className="w-full h-40 bg-gray-50 border border-gray-200 text-gray-900 rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        onKeyUp={clearErrors}
                                    ></textarea>
                                    {errors &&
                                        <p className="text-red-500 text-sm mt-2">{errors.message}</p>
                                    }
                                </div>

                                {/* 提交按钮 */}
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        id="submitBtn"
                                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg"
                                    >
                                        发送消息
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Contact;